<template>
  <div class="todo-container">
    <!-- 顶部导航栏 -->
    <header class="header">
      <div class="title-container">
        <div
          :class="['title-item', curretnIndex == 1 ? 'active' : '']"
          @click="handleTab('1')"
        >
          新零售销售数据
        </div>
        <!-- <div
          :class="['title-item', curretnIndex == 2 ? 'active' : '']"
          @click="handleTab('2')"
        >
          待办
          <div class="todoNum">{{ tableData.length }}</div>
        </div> -->
      </div>
      <div class="user-info">
        <img
          :src="userinfo.icon || 'https://picsum.photos/id/64/40/40'"
          alt="用户头像"
          class="avatar"
        />
        <span class="username">{{ userinfo.nickname }}</span>
      </div>
    </header>

    <!-- 主内容区 -->
    <main class="content">
      <div class="query-search">
        <el-input
          clearable
          style="width: 20%"
          placeholder="请输入名称"
          size="medium"
          prefix-icon="el-icon-search"
          v-model="queryParams.keyword"
        ></el-input>
        <el-button class="export-btn" size="medium" @click="getList"
          >查询</el-button
        >
      </div>

      <!-- 待办事项表格 -->
      <el-table
        :data="tableData"
        border
        size="medium"
        row-class-name="table-row"
        height="calc(100vh - 170px)"
        v-loading="tableLoading"
        :header-cell-style="headerCellStyle"
      >
        <el-table-column
          type="index"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="name"
          align="center"
          label="名称"
        ></el-table-column>
        <el-table-column
          prop="submitter"
          align="center"
          label="提交人"
        ></el-table-column>
        <el-table-column
          prop="submittime"
          align="center"
          label="提交日期"
        ></el-table-column>
        <el-table-column prop="status" align="center" label="当前状态">
          <template slot-scope="scope">
            <el-tag size="medium" :type="getStatusClass(scope.row.status).type">{{
             scope.row.status_text
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <span class="view-btn" @click="handleView(scope.row)">查看</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页控件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.page"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="queryParams.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
    </main>
  </div>
</template>

<script>
import api from "@/apis/retail";

export default {
  name: "TodoPage",
  data() {
    return {
      queryParams: {
        page: 1,
        pagesize: 10,
      },
      userinfo: JSON.parse(localStorage.getItem("store")).userInfo,
      curretnIndex: 1,
      totalCount: 0,
      tableLoading: false,
      tableData: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      api.getRetailData(this.queryParams).then((res) => {
        if (res.msg == "success") {
          this.tableData = res.data?.list || [];
          this.tableLoading = false;
          this.totalCount = res.data?.nums;
        }
      });
    },
    handleTab(index) {
      this.curretnIndex = index;
      // this.getList()
    },
    // 根据状态获取标签样式类
    getStatusClass(status) {
      let statusList  = [
        {
          label: "待确认",
          value: 0,
          type: "primary",
        },
        {
          label: "已确认",
          value: 1,
          type: "warning",
        },
        {
          label: "通过",
          value: 2,
          type: "success",
        },
        {
          label: "驳回",
          value: 3,
          type: "danger",
        }
        
      ];
      return statusList.find(item=>status==item.value)

    },

    // 查看按钮点击事件
    handleView(row) {
      const detailUrl = this.$router.resolve({
        path: "/retail/index", // 目标详情页路由路径
        query: { taskid: row.id }, // 携带行数据参数（如ID、名称等）
      }).href;
      // 在新窗口打开详情页
      window.open(detailUrl, "_blank");
    },

    // 分页大小变化
    handleSizeChange(val) {
      this.queryParams.pagesize = val;
      this.queryParams.page = 1;
      this.getList();
    },

    // 当前页码变化
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    // 表头样式
    headerCellStyle({ column, row, rowIndex, columnIndex }) {
      return {
        background: "#ECFFF0",
        fontWeight: "bold",
        color: "#333",
        textAlign: "center",
        padding: "12px 0",
      };
    },
  },
};
</script>

<style scoped lang="scss">
.todo-container {
  min-height: 100vh;
  background-color: #f5f5f5;
  font-size: 32px;
}

/* 头部样式 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px;
  height: 60px;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.title-container {
  display: flex;
  height: 100%;
  gap: 50px;
}

.title-item {
  display: flex;
  align-items: center;
  padding: 0 20px;
  //   font-size: 16px;
  color: #333;
  cursor: pointer;
  position: relative;
}

.title-item.active {
  font-weight: bold;
}

.todoNum {
  text-align: center;
  font-size: 24px;
  right: -20px;
  top: -10px;
  padding: 8px;
  position: absolute;
  background: #ff2e2e;
  border-radius: 50%;
  color: #fff;
}
.title-item.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 6px;
  background-color: #008755;
}

.user-info {
  display: flex;
  align-items: center;
}

.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 8px;
}

.username {
  color: #666;
  //   font-size: 14px;
}

/* 内容区样式 */
.content {
  padding: 20px;
  .query-search {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
    .export-btn {
      margin-left: 20px;
      color: #fff;
      transition: all 0.2s ease;
      background: #028d4e;
      border: #028d4e;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }
}

/* 表格样式 */

.table-header {
  background-color: #f7feff !important;
  color: #333;
  font-weight: 500;
}

.table-row {
  height: 60px !important;
}

/* 查看按钮样式 */
.view-btn {
  color: #008755;
  cursor: pointer;
}

.view-btn:hover {
  text-decoration: underline;
}

/* 分页样式 */
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
